const REACT_APP_API_URL = process.env.REACT_APP_API_URL;

/**
 * Resolve a Strapi cover image URL to a displayable URL.
 *
 * Strapi may return either an absolute URL (e.g. Azure blob URL) or a
 * relative path (e.g. /uploads/foo.jpg). Only prepend the CMS base URL
 * when the URL is relative.
 */
export function resolveImageUrl(url?: string | null): string | undefined {
    if (!url) return undefined;
    if (url.startsWith("http")) return url;
    return `${REACT_APP_API_URL}${url}`;
}

/**
 * Extract the best available image URL from a Strapi cover image object,
 * preferring the original, then large, medium, and thumbnail as fallback.
 */
export function getBestImageUrl(coverImage?: any): string | undefined {
    if (!coverImage) return undefined;
    const url = coverImage.url || coverImage.formats?.large?.url || coverImage.formats?.medium?.url || coverImage.formats?.thumbnail?.url;
    return resolveImageUrl(url);
}

/**
 * Extract the thumbnail URL from a Strapi cover image object.
 * Used for list/table thumbnails where small size is preferred.
 */
export function getThumbnailUrl(coverImage?: any): string | undefined {
    if (!coverImage) return undefined;
    const url = coverImage.formats?.thumbnail?.url || coverImage.url;
    return resolveImageUrl(url);
}
